import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';

import {
    Content,
    Description,
    Details,
    DetailsContainer,
    Footer as DefaultFooter,
    Title
} from '../containers/DefaultStyles/Shared';
import { MultiImageBlock } from './Image/MultiImageBlock';
import { isLongText } from './Shared/commonFunctions';
import ShareDrawer from './ShareDrawer';

import { setOverlayPartnerVisible } from '../containers/Widget/actions';
import { Placeholders } from '../utils/fillDynamicText';
import {
    relevantRepresentatives,
    joinEnglish,
    districtInfo
} from '../utils/localRepresentative/parser';
import { DefaultRepImageURL } from '../containers/DefaultStyles/Shared';
import { copyFor } from '../copy/copy';
import NextAction from '../containers/Widget/NextAction';

const Footer = styled(DefaultFooter)`
    position: absolute;
    bottom: 0;
    left: 0;
`;

const Info = styled.div`
    margin-top: 10px;
`;
const TextRow = styled.div`
    margin-top: 10px;
    a {
        color: #ff245e;
        text-decoration: none;
    }
`;

const RepsNotContactable = props => {
    return (
        <div>
            <Content
                isContactAction={true}
                useLocalRepresentative={true}
                isSingleAction={true}
            >
                <Title
                    isShortText={!isLongText(props.cardTitle, 28)}
                    isLongText={isLongText(props.cardTitle, 60)}
                    isExtraLongText={isLongText(props.cardTitle, 95)}
                    onClick={e => props.setOverlayPartnerVisible(true, e, false)}
                    dangerouslySetInnerHTML={{
                        __html: props.cardTitle
                    }}
                />
                <DetailsContainer>
                    <MultiImageBlock
                        isLongTitle={isLongText(props.cardTitle, 40)}
                        imgSources={props.localRepImages}
                    />
                    <Details hasPhoto={true}>
                        <Description
                            dangerouslySetInnerHTML={{
                                __html: props.localRepNames
                            }}
                            isSingleAction={true}
                            isLongText={isLongText(props.localRepNames, 90)}
                            isExtraLongText={isLongText(props.localRepNames, 160)}
                        />
                    </Details>
                </DetailsContainer>
            </Content>
            <Info>
                <TextRow>
                    {props.localRepImages.length > 1
                        ? copyFor('findReps', 'noContactPlural', props.activeAction.type)
                        : copyFor(
                              'findReps',
                              'noContactSingular',
                              props.activeAction.type,
                              undefined,
                              { title: props.title }
                          )}
                </TextRow>
                <TextRow
                    dangerouslySetInnerHTML={{
                        __html: props.websiteText
                    }}
                />
            </Info>
            <Footer>
                <ShareDrawer fullwidth={true} backgroundColor={'#fff'} />
            </Footer>
            <NextAction />
        </div>
    );
};

RepsNotContactable.propTypes = {
    activeAction: PropTypes.object.isRequired,
    cardTitle: PropTypes.string.isRequired,
    localRepImages: PropTypes.array.isRequired,
    localRepNames: PropTypes.string.isRequired,
    setOverlayPartnerVisible: PropTypes.func,
    title: PropTypes.string,
    websiteText: PropTypes.string.isRequired
};

export default connect(
    state => {
        const reps = state.localRep.localRepData
            ? relevantRepresentatives(
                  state.widget.activeAction.representativeSearch,
                  state.localRep.localRepData.representative
              )
            : [];

        const localRepNames = joinEnglish(
            reps.map(rep =>
                rep.title
                    ? `${rep.title} ${rep.fullName}${districtInfo(rep)}`
                    : `${rep.shortName}${districtInfo(rep)}`
            )
        );
        const currCard = state.widget.cards[state.widget.activeAction.order - 1];

        const websites = reps
            .filter(rep => rep.website)
            .map(rep => ({ name: rep.fullName, website: rep.website }));
        let websiteText;
        if (websites.length === 1) {
            websiteText = copyFor(
                'findReps',
                'websiteInfo',
                state.widget.activeAction.type,
                undefined,
                {
                    link: `<a href="${
                        websites[0].website
                    }" target="_blank" rel="noopener noreferrer">`,
                    endLink: '</a>'
                }
            );
        } else {
            websiteText = copyFor(
                'findReps',
                'websitesInfo',
                state.widget.activeAction.type
            );
            websiteText += ' ';
            websiteText += websites
                .map(
                    w =>
                        `<a href="${
                            w.website
                        }" target="_blank" rel="noopener noreferrer">${w.name}</a>`
                )
                .join(', ');
        }

        return {
            activeAction: state.widget.activeAction,
            cardTitle: (currCard.heading || state.widget.activeAction.name || '')
                .replace(/@articleUrl/g, state.widget.articleUrl)
                .replace(
                    new RegExp(Placeholders.PostalCodePlaceholder, 'g'),
                    state.localRep.localRepData.postalCode
                )
                .replace(
                    new RegExp(
                        state.widget.activeAction.type === 'tweet'
                            ? Placeholders.TwitterMentionPlaceholder
                            : Placeholders.LocalRepresentative,
                        'g'
                    ),
                    localRepNames
                )
                .replace(
                    new RegExp(Placeholders.TwitterMentionPlaceholder, 'g'),
                    joinEnglish(reps.map(rep => rep.fullName || rep.twitterMention))
                ),
            localRepImages: reps.map(rep => rep.photoUrl || DefaultRepImageURL),
            localRepNames,
            title: ((reps[0] || {}).title || 'representative').toLowerCase(),
            websiteText
        };
    },
    { setOverlayPartnerVisible }
)(RepsNotContactable);
